import VectorTileClass, * as VectorTileModule from './../../node_modules/ol/layer/VectorTile.js';

// Create a wrapper class
class VectorTile extends VectorTileClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in VectorTileModule) {
    if (key !== "default") {
        VectorTile[key] = VectorTileModule[key];
    }
}

export default VectorTile;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/layer/VectorTile.js';